import classNames from 'classnames'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { toggleScopeValue } from 'legacy/lut/components/widgets/public/partner360/programTypeButtons/components/programTypesEditor/components/programTypesEditorModal/api/toggleScopeValue'
import { selectPartnerDataEntryId } from 'legacy/lut/features/partner360/configuration'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { LoaderOverlay } from 'core-components/library/loader'

import styles from './P360NotInScopeWidgetPlaceholder.module.scss'

interface IProps {
  showMessage?: boolean
  className?: string
}

export const P360NotInScopeWidgetPlaceholder = ({ showMessage = false, className }: IProps) => {
  const [wip, setWip] = useState(false)

  const partnerDataEntryId = useSelector(selectPartnerDataEntryId)

  const addToScope = useCallback(async () => {
    setWip(true)
    await toggleScopeValue({ entryId: partnerDataEntryId, outOfScope: 0 })

    setWip(false)
    window.location.reload()
  }, [partnerDataEntryId])

  return (
    <div className={classNames(styles.root, className)}>
      <LoaderOverlay show={wip} />
      <RenderWhen condition={showMessage}>
        <div className={styles.content}>
          <div className={styles.image}>
            <i className={classNames('hpicon hpicon-sat3')}></i>
          </div>
          <div className={styles.message}>
            <h3>
              <Translation htmlAvailable text="jbp-out-of-scope" />
            </h3>
            <Button className={styles.button} onClick={addToScope}>
              <Translation text="jbp-add-to-scope-btn" />
            </Button>
          </div>
        </div>
      </RenderWhen>
    </div>
  )
}
